"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolutionConfigurationV1 = void 0;
var SolutionConfigurationV1 = /** @class */ (function () {
    function SolutionConfigurationV1(data) {
        var trackedObjectDataViewerConfiguration = data.trackedObjectDataViewerConfiguration, manageOrganizationConfiguration = data.manageOrganizationConfiguration, staticTiles = data.staticTiles, uiPreferences = __rest(data, ["trackedObjectDataViewerConfiguration", "manageOrganizationConfiguration", "staticTiles"]);
        this.dataViewerConfig = trackedObjectDataViewerConfiguration;
        this.manageOrgConfig = manageOrganizationConfiguration;
        this.staticTiles = staticTiles || null;
        this.uiPreferences = uiPreferences || null;
    }
    SolutionConfigurationV1.prototype.getDataViewerConfig = function () {
        return this.dataViewerConfig;
    };
    SolutionConfigurationV1.prototype.getManageOrgConfig = function () {
        return this.manageOrgConfig;
    };
    SolutionConfigurationV1.prototype.getStaticTiles = function () {
        return this.staticTiles;
    };
    SolutionConfigurationV1.prototype.getUIPreferences = function () {
        return this.uiPreferences;
    };
    return SolutionConfigurationV1;
}());
exports.SolutionConfigurationV1 = SolutionConfigurationV1;
//# sourceMappingURL=solutionConfiguration.js.map